// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__97xYJ","text":"SelectPayment_text__3HMTj","title":"SelectPayment_title__2eQpw","btn":"SelectPayment_btn__2WyE-"};